<template>
  

<div  class="card  border-light h-100 mb-0 pb-3" >
    <div class="card-header bg-transparent">
             
           

<div class="row">


    <div class="col">
        
        <h5 class="ml-2 text-secondary">Bon de charge (Ventes) : </h5>
        
        <div class="mt-1 ml-2 d-inline text-secondary">Zone : <span class="d-inline text-info"> {{nZon}} </span>  </div>

        <div class="mt-1 ml-2 d-inline text-secondary">    - Vendeur : <span class="d-inline text-info"> {{nVend}} </span>  </div>
        <div class="mt-1 ml-2 d-inline text-secondary">    - Bon De Charge : <span class="d-inline text-info"> {{nCharg}} </span>  </div>

    </div>

    <div class="col">
         

                <b-button pill size="sm"  class="m-2 float-right" variant="outline-primary" @click="NewBon">
                            <i class="fa fa-home"></i>
                    <span> Précédent</span> 
                </b-button>

    </div>

</div>


    </div>




    <div class="row card-body h-100 p-0">
<div class="p-0">
        <b-button v-b-toggle.collap-articl.collap-champs size="lg" class=" ml-3 mr-0 pl-1 pr-1 float-left text-secondary" variant="link">
        <i class="fa fa-bars"></i>                
        </b-button> 
</div>
  


                <b-collapse id="collap-articl" visible  class="col-2 h-100 mr-0 mt-2 p-0">


                            <div class="card border-info h-100  overflow-auto">
                            <div class="card-header  bg-info border-info p-1">
                                <b-form-input v-model="serchArt"  class="border-info" id="search-art" size="sm" placeholder="Chercher ..." type="search"></b-form-input>
                            
                            </div>

                            <b-list-group flush  >
                       
                            <b-list-group-item  v-for="item in filterArticle" :key="item.id" button class="p-1" variant="info" @click="art_click(item.id)">
                                 {{ item.ref }}
                                 <p> <small>{{item.nom_lot}} - {{item.qte}}</small> </p>
                                 </b-list-group-item>

                          

                            </b-list-group>
                            </div>






                </b-collapse>

                <div class="col h-100 overflow-auto mt-2 mr-4 ml-1">
                <b-collapse id="collap-champs" visible>

            <form @submit.prevent="handleSubmit" >

<div class="input-group  border border-info rounded bg-info p-1 justify-content-centre align-items-center text-white">
          

                <label for="client_id" class="form-control-sm m-1">Client :</label>

                <select @change="chang_clientClick(itemForm.client_id)" class="form-control form-control-sm" id="client_id" v-model="itemForm.client_id"
                :class="{ 'is-invalid': isSubmitted && $v.itemForm.client_id.$error }">
                <option v-for="item in ListClients" :key="item.id" v-bind:value="item.id">   
                {{ item.nom_prenom }} - {{ item.code }}
                </option>
                </select>
                <div v-if="isSubmitted && !$v.itemForm.client_id.required" class="invalid-feedback">Ce champ est obligatoire !!</div>



                <b-button v-if="ClientPrimCount > 0" pill size="sm"  class="m-2 float-right" variant="outline-warning" @click="prim_click(itemForm.client_id)">
                            <i class="fa fa-plus-square"></i>
                    <span> Primes  </span>
                    <b-badge variant="danger">{{ClientPrimCount}}</b-badge> 
                </b-button>

</div>



            <div class="row">
            <div class="form-group col">
                <label for="ref" class="form-control-sm mb-0">Référence</label>
                <input type="text" v-model="itemForm.ref" id="ref" name="ref" class="form-control form-control-sm"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.ref.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.ref.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
            </div>
            <div class="form-group col">
                <label for="nom_lot" class="form-control-sm mb-0">Lot</label>
                <input type="text" v-model="itemForm.nom_lot" id="nom_lot" name="nom_lot" class="form-control form-control-sm"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.nom_lot.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.nom_lot.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
            </div>

            </div>

            <div class="row"> 
          <div class="form-group col">
                <label for="qte_vend" class="form-control-sm mb-0">Quantité Vendue : </label>
                <input type="text" v-model="itemForm.qte_vend" id="qte_vend" name="qte_min" class="form-control form-control-sm"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.qte_vend.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.qte_vend.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
                <div v-if="isSubmitted && !$v.itemForm.qte_vend.decimal" class="invalid-feedback">Entrez une valeur numérique !!</div>
            </div>


          <div class="form-group col">
                <label for="qte_retour" class="form-control-sm mb-0">Quantité Retour : </label>
                <input type="text" v-model="itemForm.qte_retour" id="qte_retour" name="qte_retour" class="form-control form-control-sm"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.qte_retour.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.qte_retour.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
                <div v-if="isSubmitted && !$v.itemForm.qte_retour.decimal" class="invalid-feedback">Entrez une valeur numérique !!</div>
            </div>


            </div>

  
            <div class="form-group">
                <label for="prix" class="form-control-sm mb-0">Prix TTC : </label>
                <input type="text" v-model="itemForm.prix" id="prix" name="prix" class="form-control form-control-sm"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.prix.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.prix.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
                <div v-if="isSubmitted && !$v.itemForm.prix.decimal" class="invalid-feedback">Entrez une valeur numérique !!</div>
            </div>

            <div class="form-group">
            <textarea name="description" id="description"  rows="2"  placeholder="Description ..." class="form-control form-control-sm" v-model="itemForm.description"></textarea>
            </div>

            <div class="form-group">
                <button type="submit" class="btn btn-secondary btn-block">Ajouter Article/Produit</button>
            </div>

            </form>
</b-collapse>

            

                      <b-table 
        sort-icon-left
        small 
        responsive 
        :fields="fieldsArticle" 
        :items="ArticlesList"
        >
            <template #cell(actions)="row">
                    <b-button pill size="sm"  class="mr-2 float-right" variant="outline-danger" @click="del_click(row.item)">
                                <i class="fa fa-trash-alt"></i>
                        
                    </b-button>
            </template>
        
        </b-table>


         

</div>

  </div>


    <!-- le modal -->
    <b-modal id="detailModal" size="lg" hide-footer>


       <b-table 
        small 
        borderless
        striped 
        sticky-header
        :fields="fieldsPrimes" 
        :items="ShowPrimsClients"
        >

        
        </b-table>


            <div class="form-group">
                <button type="submit" class="btn btn-secondary btn-block" @click="validPrim_Click(itemForm.client_id)">Valider Les Primes</button>
            </div>

    </b-modal>




      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#0179F9" loader='bars'></loading>

 </div>






  
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {required,decimal} from "vuelidate/lib/validators";

export default {
 props: ['idZon','nZon','idCharg','nCharg','nVend','id_Vend','idPrime','is_val','is_stockval'],

 
    computed: {

    filterArticle() {
            return this.listArt.filter(article => {

                return article.ref.toLowerCase().includes(this.serchArt.toLowerCase())

      })
    },
    },
    mounted(){

            if(this.idCharg)
            {
            this.charge_arts(this.idCharg)
            this.fetchClientsList()
            this.fetchListArts(this.idCharg)
            this.fetchListPrimes(this.idPrime)
            }
            else
            {
            this.flashMessage.show({
                                            status: 'error',
                                            title: 'Erreur de Chargement',
                                            message: 'Impossible charger les données de ce bon'
            })
            }




    },
    data () {
		return {

            fieldsPrimes: [
                {key: 'client', label: 'Client'},
                {key: 'ref', label: 'Réf'},
                {key: 'qte', label: 'Quantité'},
                {key: 'nom_lot', label: 'Lot'},
            ],
            ShowPrimsClients:[],
            fieldsArticle: [
                {key: 'ref', label: 'Réf'},
                {key: 'qte_vend', label: 'Qte Ventes'},
                {key: 'qte_retour', label: 'Qte Retour'},
                {key: 'prix', label: 'Prix'},
                {key: 'nom_lot', label: 'Lot'},
                {key: 'description', label: 'Description'},
                { key: 'actions', label: '' }
            ],
            ListClients:[],
            primItems:[],
            ClientPrimCount:0,
            serchArt:'',
            ArticlesList:[],
            listCat: [],
            listArt: [],
            itemForm: {
                    id:'',
                    ref:'',
                    description:'',
                    nom_lot:'',
                    prix:'',
                    qte_vend:'',
                    qte_retour:'',
                    charge_detail_id:'',
                    article_id:'',
                    client_id:''},
            isSubmitted: false,
            isLoading: false
		}
    },
    validations: {
            itemForm: {
                ref: {
                    required
                },
                nom_lot: {
                    required
                },
                prix: {
                    required,
                    decimal
                },
                qte_vend: {
                    required,
                    decimal
                },
                qte_retour: {
                    required,
                    decimal
                },

                charge_detail_id: {
                    required
                },
                article_id: {
                    required
                },
                client_id: {
                    required
                }
            }

    },
    methods:{

        fetchListPrimes(id_prim)
        {
                    this.isLoading=true;
                    this.$http.get('/detailPrimClient/'+id_prim)
                    .then((result) => {
                                this.primItems = result.data.data
                                this.isLoading=false;

                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });


        },
        fetchClientsList: function () {
                    this.isLoading=true;
                    this.$http.get('/clientMinDeZone/'+this.idZon)
                    .then((result) => {
                                this.ListClients = result.data.data
                                this.isLoading=false;
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });
        },
        charge_arts(id_chrg)
        {
                    this.isLoading=true;
                    this.$http.get('/bnChargeDetailItems/'+id_chrg)
                    .then((result) => {
                                this.listArt = result.data.data

                                
                                this.isLoading=false;


                                //effacer le search:
                                this.serchArt=''
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });

        },
        art_click(id_chrg)
        {

            let art = this.listArt.findIndex(item => item.id === id_chrg)
            
            this.itemForm.ref=this.listArt[art].ref
            this.itemForm.nom_lot=this.listArt[art].nom_lot
            this.itemForm.description=this.listArt[art].description
            this.itemForm.prix = this.listArt[art].prix
            this.itemForm.qte_vend = 1
            this.itemForm.qte_retour = 0
            this.itemForm.charge_detail_id=this.listArt[art].id
            this.itemForm.article_id=this.listArt[art].id
            
        },
        fetchListArts(id_bn)
        {
                    this.isLoading=true;
                    this.$http.get('/bnChargeVentesItems/'+id_bn)
                    .then((result) => {
                                this.ArticlesList = result.data.data
                                this.isLoading=false;

                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });


        },
        handleSubmit(){


                //set nom lot
                if(this.itemForm.lot_id)
                {
                let am = this.ListLots.findIndex(item => item.id === this.itemForm.lot_id)
                this.itemForm.nom_lot= this.ListLots[am].nom
                }



                this.isSubmitted = true;

                this.$v.$touch();
                if (this.$v.$invalid) {
                this.flashMessage.show({
                status: 'info',
                title: 'Vérifiez les données et Reésayez !!',
                })
                }
                else 
                {

                            this.isLoading=true;

                            this.$http.post('/bnChargeVente',{
                            ref:this.itemForm.ref,
                            description:this.itemForm.description,
                            nom_lot:this.itemForm.nom_lot,
                            prix:this.itemForm.prix,
                            qte_vend:this.itemForm.qte_vend,
                            qte_retour:this.itemForm.qte_retour,
                            charge_detail_id:this.itemForm.charge_detail_id,
                            article_id:this.itemForm.article_id,
                            client_id:this.itemForm.client_id,
                            bn_charge_id: this.idCharg

                                })
                                .then(response => {

                                    this.isLoading=false;
                                    this.ArticlesList.unshift(response.data.data);

                                    //desactiver la validation:
                                    this.isSubmitted=false
                                    //afficher message
                                    this.flashMessage.show({
                                    status: 'success',
                                    title: 'Données sauvegardées',
                                    message: 'Les données sont sauvegardées correctement '
                                })


                                })
                                .catch(error=> {console.log(error)
                                this.isLoading=false;


                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur De Sauvegarde',
                                message: 'Impossible  de sauvegarder les données .. Réessayez !!'
                                })
                                });
                           

                }

        },
        del_click(itemA){

            this.isLoading=true;

            this.$http.delete('/bnChargeVente/'+itemA.id)
                .then(response => {
                console.log(response.data)
                this.isLoading=false;   
                this.flashMessage.show({
                status: 'success',
                title: 'Données Supprimées',
                message: 'Les données sont supprimées correctement'
                })
                    let index = this.ArticlesList.findIndex(item => item.id === itemA.id)

                    this.ArticlesList.splice(index, 1)
                })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Suppression',
                message: 'Impossible  de supprimer les données .. Réessayez !!'
                })
                });

        },
        NewBon()
        {


                        this.$router.push({ 
                        name: 'bonDecharge', 
                        params: { 
                        idZon: this.idZon,
                        nZon: this.nZon,
                        idCharg: this.idCharg,
                        nCharg: this.nCharg,
                        nVend: this.nVend,
                        id_Vend: this.id_Vend,
                        idPrime:this.idPrime,
                        is_val:this.is_val,
                        is_stockval:this.is_stockval                  
                        } 
                         });
        },
        chang_clientClick(if_client)
        {
                 var newArray = this.primItems.filter(function (el) {
                    return el.client_id ==if_client &&
                            el.etat ==0;
                 });



                 if(newArray.length>0)
                 {
                        this.ClientPrimCount=newArray.length
                 }
                 else
                 {
                            this.ClientPrimCount=0
                 }
        },
        prim_click(if_client)
        {
                   var newArray = this.primItems.filter(function (el) {
                            return el.client_id ==if_client &&
                            el.etat ==0;
                    });


                    if(newArray.length>0)
                    {
                            this.ShowPrimsClients=newArray
                    }

        this.$root.$emit('bv::show::modal', 'detailModal')
        },
        validPrim_Click(if_client)
        {

           
                             this.isLoading=true;
                    this.$http.get('/changEtatPrimes/'+this.idPrime+'/'+if_client+'/1')
                    .then((result) => {

                    console.log(result)


                //effacher les valider:



                 var newArray = this.primItems.filter(function (el) {
                    return el.client_id != if_client;
                 });



                 if(newArray.length>0)
                 {
                        this.primItems=newArray
                 }


                    let index = this.primItems.findIndex(item => item.client_id === if_client)
                    this.primItems.splice(index, 1)



                    this.$bvModal.hide('detailModal')

                    //reafficher le boutton:
                    this.chang_clientClick(if_client)

                                this.isLoading=false;

                                                                    //afficher message
                                    this.flashMessage.show({
                                    status: 'success',
                                    title: 'Données sauvegardées',
                                    message: 'Les données sont sauvegardées correctement '
                                })

                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur De Sauvegarde',
                                message: 'Impossible  de sauvegarder les données .. Réessayez !!'
                                })
                    });
        }



        },
        components: {
                    Loading      
        }


}
</script>

<style>
/*------scroll bar---------------------*/

::-webkit-scrollbar {
  width: 5px;
  height: 7px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #9cc7f9;
  border: 0px none #ffffff;
  border-radius: 0px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9cc7f9;
}
::-webkit-scrollbar-thumb:active {
  background: #9cc7f9;
}
::-webkit-scrollbar-track {
  background: transparent;
  border: 0px none #ffffff;
  border-radius: 60px;
}
::-webkit-scrollbar-track:hover {
  background: transparent;
}
::-webkit-scrollbar-track:active {
  background: transparent;
}
::-webkit-scrollbar-corner {
  background: transparent;
}

</style>